import React from 'react';
import { FormControl } from '@/components';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import classNames from 'classnames';

const LanguageSelect = ({ metadata, className, onChange, ...props }) => {
  const router = useRouter();
  const { t } = useTranslation('common');

  const normalizeLanguage = (lang = '') => {
    const value = lang.toLowerCase();
    return value === 'en-us' ? 'en' : value;
  };

  const languageChange = (event) => {
    const selectedValue = event.target.value;

    const lang = metadata.languages.find(
      (item) => normalizeLanguage(item.language) === normalizeLanguage(selectedValue),
    );

    if (!lang) return;

    document.cookie = `NEXT_LOCALE=${lang.language}; path=/;`;
    onChange && onChange(event);
    window.location.href = lang.languageUrl;
  };

  const currentLocale =
    metadata.languages.find((item) => normalizeLanguage(item.language) === normalizeLanguage(router.locale))
      ?.language ?? router.locale;

  const languageOrder = {
    en: ['tr', 'de', 'ru'],
    tr: ['en-us', 'de', 'ru'],
    ru: ['tr', 'en-us', 'de'],
    de: ['tr', 'en-us', 'ru'],
  };

  const order = languageOrder[normalizeLanguage(router.locale)] || [];

  // Tüm diller (butonda seçili dili göstermek için)
  const allOptions = metadata.languages.map((item) => ({
    label: t(`language.$${item.language.replace('-', '')}`),
    value: item.language,
  }));

  const dropdownOptions = order
    .map((lang) => {
      const item = metadata.languages.find((x) => normalizeLanguage(x.language) === normalizeLanguage(lang));

      if (!item) return null;

      return {
        label: t(`language.$${item.language.replace('-', '')}`),
        value: item.language,
      };
    })
    .filter(Boolean);

  return (
    <FormControl
      aria-label={t('general.$languageSwitcher')}
      type="select"
      required
      name="language"
      value={currentLocale}
      className={classNames(
        'font-montserrat text-sm not-italic font-medium leading-5 tracking-button-reg uppercase ' +
          '[&_.main-button]:bg-transparent [&_.main-button]:border-transparent ' +
          '[&_.popover-title]:font-montserrat [&_.popover-title]:text-sm [&_.popover-title]:not-italic [&_.popover-title]:font-medium [&_.popover-title]:leading-5 [&_.popover-title]:tracking-button-reg [&_.popover-title]:uppercase ' +
          '[&_.main-button_svg]:stroke-brand-soft-white [&_.main-button_svg]:ml-2 ' +
          '[&_.content]:rounded-sm [&_.content_ul]:py-0 [&_.content_.option]:border-b [&_.content_.option]:border-b-black/25 ' +
          '[&_.content_.option]:text-center [&_.content_.option]:p-1.5 [&_.content_.option]:text-black ',
        className,
      )}
      options={allOptions}
      dropdownOptions={dropdownOptions}
      onChange={languageChange}
      {...props}
    />
  );
};

export default LanguageSelect;
